import type { CatalogResponse } from '../../../types/analytics';
import type { ChatMessage } from '../../../types/chat';

export const DASHBOARD_STARTERS = [
  'Build an AP overview with total spend, spend by vendor, and overdue invoices',
  'Show spend by vendor over the last quarter',
  'Create a dashboard of invoices by status and monthly spend',
];

export function buildDashboardPrimer(catalog: CatalogResponse | undefined): ChatMessage {
  const metricLine = catalog?.metrics?.length
    ? catalog.metrics.map((m) => `• ${m.label}`).join('\n')
    : '• (loading the metric catalog…)';
  const content =
    "Let's build a dashboard. I can chart these AP metrics:\n" +
    `${metricLine}\n\n` +
    'Tell me what you want — e.g. "an AP overview with spend and aging" — ' +
    "and I'll propose a dashboard for you to confirm.";
  return {
    id: crypto.randomUUID(),
    type: 'assistant',
    content,
    timestamp: new Date(),
  };
}
